import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HelpBreadcrumb = ({ moduleTitle }) => {
  const { t } = useTranslation();
  return (
    <nav aria-label="breadcrumb" className="help-breadcrumb">
      <ol className="breadcrumb mb-0">
        <li className="breadcrumb-item">
          <Link to="/ayuda">
            <i className="bi bi-question-circle me-1" aria-hidden="true"></i>
            {t('help.title', 'Ayuda')}
          </Link>
        </li>
        {moduleTitle && (
          <li className="breadcrumb-item active" aria-current="page">
            {moduleTitle}
          </li>
        )}
      </ol>
    </nav>
  );
};

export default HelpBreadcrumb;
